'use strict';
const assert = require('assert');
const Utilities = require('../utilities');
const chai = require('chai');
const sdkConfiguration = require('../../configurations/sdk-configuration');

const credentials = {
  domain: 'csDesarrollo.onmicrosoft.com',
  clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
  userName: 'app@csDesarrollo.onmicrosoft.com',
  password: 'Inn0vaci0n',
};
const fakeCustomerId = '874512';
const fakeRequest = options => Promise.resolve(options);

const expect = chai.expect;
/* eslint-disable no-undef, no-unused-vars */
describe('Utilities', () => {
  it('Creates a correct instance of the class', (done) => {
    const utilities = new Utilities(credentials, fakeRequest, sdkConfiguration);
    expect(utilities).to.have.property('requestManager');
    expect(utilities.requestManager).to.have.property('requestConfigurationManager');
    expect(utilities.requestManager).to.have.property('authConfiguration');
    expect(utilities.requestManager.requestConfigurationManager).to.have.property('sdkConfiguration');
    expect(utilities.requestManager.requestConfigurationManager).to.have.property('credentials');
    expect(utilities.requestManager.requestConfigurationManager).to.have.property('request');
    expect(utilities).to.have.property('paramsManager');
    expect(utilities.paramsManager).to.have.property('pathParams');
    expect(utilities.paramsManager).to.have.property('bodyParams');
    expect(utilities.paramsManager).to.have.property('queryParams');
    done();
  });
  it('deleteCustomer, deletes an integration customer', (done) => {
    const utilities = new Utilities(credentials, fakeRequest, sdkConfiguration);
    utilities.deleteCustomer(fakeCustomerId).then((deleteRequest) => {
      assert(deleteRequest.method === 'DELETE');
      assert(deleteRequest.uri === 'https://api.partnercenter.microsoft.com/v1/customers/874512');
      assert(deleteRequest.headers.Accept === 'application/json');
      assert(deleteRequest.headers['Content-Type'] === 'application/json');
      expect(deleteRequest.headers).to.have.property('MS-RequestId');
      expect(deleteRequest.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getDomainAvailability, get a boolean value to check if the domain is available', (done) => {
    const utilities = new Utilities(credentials, fakeRequest, sdkConfiguration);
    utilities.getDomainAvailability('fakeDomain').then((domainAvailavility) => {
      assert(domainAvailavility.method === 'GET');
      assert(domainAvailavility.uri === 'https://api.partnercenter.microsoft.com/v1/validations/checkdomainavailability/fakeDomain');
      assert(domainAvailavility.headers.Accept === 'application/json');
      assert(domainAvailavility.headers['Content-Type'] === 'application/json');
      expect(domainAvailavility.headers).to.have.property('MS-RequestId');
      expect(domainAvailavility.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getAddressRules, get the address rules for market', (done) => {
    const utilities = new Utilities(credentials, fakeRequest, sdkConfiguration);
    utilities.getAddressRules('MX').then((addressRules) => {
      assert(addressRules.method === 'GET');
      assert(addressRules.uri === 'https://api.partnercenter.microsoft.com/v1/countryvalidationrules/MX');
      assert(addressRules.headers.Accept === 'application/json');
      assert(addressRules.headers['Content-Type'] === 'application/json');
      expect(addressRules.headers).to.have.property('MS-RequestId');
      expect(addressRules.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('getPartnerActivityRecords, get the partner activity records', (done) => {
    const utilities = new Utilities(credentials, fakeRequest, sdkConfiguration);
    utilities.getPartnerActivityRecords('2017-01-01', '2017-01-20').then((activityRecords) => {   
      assert(activityRecords.method === 'GET');
      assert(activityRecords.uri === 'https://api.partnercenter.microsoft.com/v1/auditrecords?startDate=2017-01-01&endDate=2017-01-20');
      assert(activityRecords.headers.Accept === 'application/json');
      assert(activityRecords.headers['Content-Type'] === 'application/json');
      expect(activityRecords.headers).to.have.property('MS-RequestId');
      expect(activityRecords.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
});
